import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ShoppingBasket, Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { HERO_IMG } from "../lib/categories";
import logo from "../assets/afrigate-logo.png";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [sp] = useSearchParams();
  const next = sp.get("next") || "/admin";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const STAFF = ["admin", "ops", "picker", "packer", "loader", "inbound", "delivery", "support"];
  useEffect(() => {
    if (user && STAFF.includes(user.role)) navigate(next);
  }, [user, navigate, next]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await login(email, password);
      navigate(next);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  const input = "w-full bg-white border border-black/10 rounded-xl px-4 py-3 focus:ring-2 focus:ring-[#306D29] focus:outline-none";

  return (
    <div className="min-h-screen flex items-center justify-center px-5 relative overflow-hidden">
      <img src={HERO_IMG} alt="" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-[#0D530E]/80" />
      <div className="relative bg-[#FBF5DD] rounded-3xl p-9 max-w-sm w-full shadow-2xl">
        <div className="flex flex-col items-center gap-3 mb-8">
          <img src={logo} alt="AfriGate" className="h-[72px] w-auto" data-testid="admin-logo" />
          <span className="inline-flex items-center gap-2 text-xs font-semibold text-[#306D29] bg-[#306D29]/10 rounded-full px-3.5 py-1.5">
            <ShoppingBasket size={15} /> Ops &amp; Store Admin
          </span>
        </div>
        <h1 className="font-display text-2xl mb-1">Admin sign in</h1>
        <p className="text-[#5C5C5C] text-sm mb-6">Manage products, orders and tracking.</p>
        <form onSubmit={submit} className="space-y-3" data-testid="admin-login-form">
          <input type="email" required className={input} placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" />
          <input type="password" required className={input} placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" />
          {error && <p className="text-[#306D29] text-sm" data-testid="admin-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-submit"
            className="w-full bg-[#306D29] hover:bg-[#0D530E] text-white font-semibold py-3.5 rounded-full flex items-center justify-center gap-2 disabled:opacity-60"
            style={{ transition: "background-color 0.2s ease" }}>
            {loading && <Loader2 size={18} className="animate-spin" />} Sign in
          </button>
        </form>
      </div>
    </div>
  );
}
